import { useEffect, useMemo, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import { useTenantOptions } from "../../hooks/useTenantOptions";
import {
  useGetBoMeQuery,
  TENANT_CONTEXT_ALL,
  TENANT_CONTEXT_CHANGED_EVENT,
  readBoTenantContext,
  setBoTenantContext,
} from "../../store/services/api";

// MT-012 — Selector de tenant en el header del BO.
// - Visible solo para SUPER_ADMIN (dropdown con "Todos" + tenants, GRUPS primero).
// - TENANT_ADMIN ve un badge con el nombre de su tenant (scope fijo).
// - La selección persiste en sessionStorage y se envía como X-Tenant-Context (ver api.ts).
//   Al cambiar se recarga la vista para refiltrar todas las queries.
// La lista sale de useTenantOptions, la misma que usan los filtros de las pantallas.
export const TenantSelector = () => {
  const { data: me, isLoading } = useGetBoMeQuery();
  const { options: tenantOptions } = useTenantOptions();
  const [current, setCurrent] = useState(readBoTenantContext);

  useEffect(() => {
    const syncFromStorage = () => setCurrent(readBoTenantContext());
    window.addEventListener(TENANT_CONTEXT_CHANGED_EVENT, syncFromStorage);
    return () =>
      window.removeEventListener(TENANT_CONTEXT_CHANGED_EVENT, syncFromStorage);
  }, []);

  const options = useMemo(
    () => [{ label: "Todos", value: TENANT_CONTEXT_ALL }, ...tenantOptions],
    [tenantOptions]
  );

  if (isLoading || !me) return null;

  if (me.role !== "SUPER_ADMIN") {
    const ownTenant = me.tenants.find((t) => t.id === me.tenantId);
    return (
      <Tag
        value={ownTenant?.provider || me.tenantId}
        severity="info"
        className="align-self-center"
      />
    );
  }

  const handleChange = (value: string) => {
    setBoTenantContext(value);
    // Si la URL trae tenantId (métricas detalle), alinearlo antes de recargar para
    // que el filtro de la pantalla coincida con el topbar.
    const url = new URL(window.location.href);
    if (url.searchParams.has("tenantId")) {
      url.searchParams.set("tenantId", value);
      window.location.assign(url.toString());
      return;
    }
    // Refetch global: la forma más simple y confiable de refiltrar todo el BO.
    window.location.reload();
  };

  return (
    <Dropdown
      inputId="tenant-selector"
      value={current}
      options={options}
      optionLabel="label"
      optionValue="value"
      onChange={(e) => handleChange(e.value)}
      className="align-self-center"
      placeholder="Tenant"
      style={{ minWidth: "12rem" }}
    />
  );
};
